export default "__VITE_ASSET__HU2s7wQ6__"